/**
 * Documentation Controller
 */
function DocumentationCtrl(
    WCConstants,
    categories,
    $window,
    $log,
    documentationService
) {
    var vm = this;

    vm.version = WCConstants.version;
    vm.categories = categories;
    vm.documentations = null;

    vm.handleCategoryClick = function (category) {
        // ensure only the appropriate category is selected (if we want to style it)
        angular.forEach(vm.categories, function unselect(c) {
            c.selected = false;
        });
        category.selected = true;

        vm.documentations = category['documentations'];
    };

    vm.handleDocumentationClick = function (documentation) {
        var url = documentationService.getDocumentationURL(documentation);
        if (url == null) {
            $log.info('URL inconnu pour la tuile sélectionnée', documentation); // TODO: open a pop-up for the end-user ?
            return;
        }
        $window.open(url, '_blank');
    };

    // if user is logged out in another tab, reload the portal
    $window.addEventListener('storage', function () {
        $window.location.reload();
    });

    vm.handleCategoryClick(vm.categories[0]);

    return vm;
}

angular.module('app.portail.documentation').controller('DocumentationCtrl', DocumentationCtrl);
